module.exports = __webpack_public_path__ + "static/media/majorC4.d84e3ca.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorC4.wav
// module id = 0XE8
// module chunks = 0